import React from 'react';
import { commonLang, isSystem } from '@umu/ukit-lang';
import { VERSION_TYPE} from '@umu/umu-types';

import './index.scss';
import { $window } from '@umu/umu-dom';
interface IEnterpriseExpireData {
    left_day: number;
    expire_date: number;
    version_type: string;
}
interface IProps {
    onClose(): void;
    data: {
        left_day: number;
        expire_date: string;
        version_type: string;
    };
}
enum MAP_TYPE_EXPIRE {
    __INIT__,
    ENTERPRISE,
    TEAM,
    INSTITUTION
}
const expireMsgMap = {
    [MAP_TYPE_EXPIRE.__INIT__]: {
        versionText: commonLang('UMU账户'),
        content: [
            commonLang('<p class="expire-rows">您的服务到期日是 <span class="due-date-color">${dueDate}</span> ，将于${leftDay}到期，请尽快联系 UMU 客户经理续期。如果到期日前未完成续期，课程小节数据导出、管理后台、企业题库、企业模板等部分高级功能将受限不可用。<p>'),
            commonLang('<p class="expire-rows">如果您已确认不再续期，请于 ${dueDate} 之前完成所需数据的下载保存；同时请告知其他讲师尽快完成课程数据的下载保存。</p>'),
            commonLang('<p class="expire-rows">您也可以随时联系 UMU 客户经理进行沟通或续期。</p>')
        ],
        isAllowRenew: false,
        btnCancelText: '',
        btnConfirmText: commonLang('知道了')
    },
    [MAP_TYPE_EXPIRE.ENTERPRISE]: {
        versionText: commonLang('企业版'),
        isAllowRenew: false,
        btnCancelText: '',
        btnConfirmText: commonLang('知道了'),
        content: [
            commonLang('<p class="expire-rows">您的企业版服务到期日是 <span class="due-date-color">${dueDate}</span> ，将于${leftDay}到期，请尽快联系 UMU 客户经理续期。如果到期日前未完成续期，课程小节数据导出、管理后台、企业题库、企业模板等部分高级功能将受限不可用。<p>'),
            commonLang('<p class="expire-rows">如果您已确认不再续期企业版，请于 ${dueDate} 之前完成所需数据的下载保存；同时请告知其他讲师尽快完成课程数据的下载保存。</p>'),
            commonLang('<p class="expire-rows">您也可以随时联系 UMU 客户经理进行沟通或续期。</p>')
        ],
    },

    [MAP_TYPE_EXPIRE.TEAM]: {
        versionText: commonLang('团队版'),
        isAllowRenew: true,
        btnCancelText: commonLang('取消'),
        btnConfirmText: commonLang('去续费'),
        content: [
            commonLang('<p class="expire-rows">您的团队版服务到期日是 <span class="due-date-color">${dueDate}</span> ，将于${leftDay}到期，请尽快完成 <a href="${linkRenew}">续费</a> 。如果到期日前未完成续费，学习平台将自动降级；降级后课程小节数据导出、管理后台、企业题库、企业模板等部分高级功能将受限不可用。</p>'),
            commonLang('<p class="expire-rows">如果您已确认不再续费团队版，请于 ${dueDate} 之前完成所需数据的下载保存；同时请告知其他讲师尽快完成课程数据的下载保存。</p>'),
            commonLang('<p class="expire-rows">您也可以随时在“管理后台 - 数据中心 - 数据概况”页面完成续费。</p>')
        ],
    },
    [MAP_TYPE_EXPIRE.INSTITUTION]: {
        versionText: commonLang('机构版'),
        isAllowRenew: false,
        btnCancelText: '',
        btnConfirmText: commonLang('知道了'),
        content: [
            commonLang('<p class="expire-rows">您的机构版服务到期日是 <span class="due-date-color">${dueDate}</span> ，将于${leftDay}到期，请尽快联系 UMU 客户经理续期。如果到期日前未完成续期，课程小节数据导出、管理后台、企业题库、企业模板等部分高级功能将受限不可用。<p>'),
            commonLang('<p class="expire-rows">如果您已确认不再续期机构版，请于 ${dueDate} 之前完成所需数据的下载保存；同时请告知其他讲师尽快完成课程数据的下载保存。</p>'),
            commonLang('<p class="expire-rows">您也可以随时联系 UMU 客户经理进行沟通或续期。</p>')
        ],
    },
};
/**
 * @desc 团队版续费链接
*/
const onTeamRenewUrls = () => {
    let urls = '/plan/payment?plan=3&purchase=2&platform=mobile';
    if (!isSystem('CN')) {
        urls = '/plan/subscription?plan=3&purchase=2&platform=twww'
    }
    return urls;
}
const enterpriseList = [VERSION_TYPE.ENTERPRISE, VERSION_TYPE.ENTERPRISE_COMMON];// 企业版本对应版本值
const mechanismList = [VERSION_TYPE.INSTITUTE, VERSION_TYPE.INSTITUTE_COMMON];// 机构版
const teamList = [VERSION_TYPE.COMMERICAL];// 团队版
const getEnterpriseExpireMsg = (versionType: number) => {
    let msgType = MAP_TYPE_EXPIRE.__INIT__;
    if (enterpriseList.includes(versionType)) {
        msgType = MAP_TYPE_EXPIRE.ENTERPRISE;
    }
    if (mechanismList.includes(versionType)) {
        msgType = MAP_TYPE_EXPIRE.INSTITUTION
    }
    if (teamList.includes(versionType)) {
        msgType = MAP_TYPE_EXPIRE.TEAM;
    }
    return expireMsgMap[msgType];
};
const onTransformMsgContent = (text: string, info: Record<string, string>) => {
    let result = text;
    for (var keys in info) {
        const replaceKey = '${' + keys + '}';
        result = result.replace(replaceKey, info[keys]);
        if (result.indexOf(replaceKey) !== -1) {// 对二次出现值进行判断
            result = result.replace('${' + keys + '}', info[keys]);
        }
    }
    return result;
};

const EnterpriseExpireDialog = (props: IProps) => {
    const { left_day: leftDay, expire_date: expireDate, version_type: versionType } = props.data;
    const isToDay = String(leftDay) === '0';
    const urls = onTeamRenewUrls();
    const msg = getEnterpriseExpireMsg(Number(versionType));
    let title = isToDay ? commonLang('${version}将于今天到期') : commonLang('${version}{$0{0=天, 1=天}}后到期', leftDay);
    title = title.replace('${version}', msg.versionText);

    const content = onTransformMsgContent(msg.content.join(''), {
        dueDate: expireDate,
        leftDay: isToDay ? commonLang('今天') : commonLang('{$0{0=天后, 1=天后}}', leftDay),
        linkRenew: urls
    });
    const onConfirmClick = () => {
        if (msg.isAllowRenew) {
            $window.location.href = urls;
        }
        props.onClose()
    }
    return <div className='enterprise-expire-dialog'>
        <div className='expire-title'>
            {title}
        </div>
        <div className='expire-content' dangerouslySetInnerHTML={{
            __html: content,
        }}></div>
        <div className='expire-footer'>
            {msg.btnCancelText && <div className='btn-cancel-text btn-text' onClick={props.onClose}>{msg.btnCancelText}</div>}
            <div className={`btn-confirm-text ${msg.btnCancelText ? '' : 'btn-text'}`} onClick={onConfirmClick}>{msg.btnConfirmText}</div>
        </div>
    </div>
}

export {
    IEnterpriseExpireData,
    EnterpriseExpireDialog
}
